// react
import { useContext } from 'react';

// router
import { useSearchParams } from 'react-router-dom';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextActs } from '../Project.context';

// mui
import { Container, Grid, Typography } from '@mui/material';

// tables
import { TableActs } from '../../../tables/cards/TableActs/TableActs';

// dialogs
import { DialogAddAct } from '../../../dialogs/DialogAddAct/DialogAddAct';

export const Acts = () => {
	// hooks
	const [searchParams, setSearchParams] = useSearchParams('');
	const { t } = useTranslation();

	// context
	const { acts, isLoadingActs, paginationActs, refetchActs } = useContext(ContextActs);

	// params
	const paramDialog = searchParams.get('dialog');

	const handleCloseDialog = () => {
		searchParams.delete('dialog');
		setSearchParams(searchParams);
	};

	return (
		<>
			<Container maxWidth={false}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography variant="h2">{t('activities')}</Typography>
					</Grid>
					<Grid item xs={12}>
						<TableActs
							acts={acts}
							isLoading={isLoadingActs}
							pagination={paginationActs}
							refetchActs={refetchActs}
						/>
					</Grid>
				</Grid>
			</Container>
			<DialogAddAct
				isOpen={paramDialog === 'addActivity'}
				onClose={handleCloseDialog}
				onSuccess={() => {
					refetchActs();
				}}
			/>
		</>
	);
};
